import {DealSensitivityOverview, EMPTY_DEAL_SENSITIVITY_OVERVIEW} from "../../models/deal-sensitivity-overview";
import {DealSensitivity, EMPTY_DEAL_SENSITIVITY} from "../../models/deal-sensitivity";
import {ApiDataModel} from "../../../shared/model/api-data-model";

export const ALL_CASE_TOKENS = ["weighted", "low", "base", "high"] as const;
export const ALL_PERF_TOKENS = ["netPerf", "grossPerf", "navUplift"] as const;
export const DEFAULT_COLUMN_TOKENS: string[] = ALL_CASE_TOKENS.flatMap(c =>
    ALL_PERF_TOKENS.map(p => `${c}_${p}`)
);

export const COLUMN_TOKENS_STORAGE_KEY = "valumize.deal-sensitivity.columnTokens";

function loadPersistedColumnTokens(): string[] {
    try {
        const raw = localStorage.getItem(COLUMN_TOKENS_STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.every((t: unknown) => typeof t === "string")) return parsed;
        }
    } catch { /* ignore malformed data */
    }
    return DEFAULT_COLUMN_TOKENS;
}

export interface DealSensitivityState {
    dealSensitivityOverview: ApiDataModel<DealSensitivityOverview>;
    dealSensitivity: ApiDataModel<DealSensitivity>;
    selectedColumnTokens: string[];
}

export const INITIAL_STATE: DealSensitivityState = {
    dealSensitivityOverview: {
        data: EMPTY_DEAL_SENSITIVITY_OVERVIEW,
        status: "INIT",
        errorMessage: ""
    },
    dealSensitivity: {
        data: EMPTY_DEAL_SENSITIVITY,
        status: "INIT",
        errorMessage: ""
    },
    selectedColumnTokens: loadPersistedColumnTokens(),
};
